import React from 'react';
import * as S from "./style";
import { CTAOfferButton } from '../../../../common/styled-components/styled-components';
import LearningPathImg from "~images/sem/learning_path.svg";
import Image from '../../../../../../app/js/components/loggedout/common/Image';
import { Link } from 'react-router-dom';
import Routes from '../../../../routes/routes';
import { deepCoveDark } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import LayeredBackground from "~images/sem/layer.svg";

const LearningHabit = ({trackPromoPageEvents, settings}) => {
  let ctaText = settings.trial_days ? `Try for free` : 'Subscribe Now';
  return (
    <S.ContainerWrapper>
      <S.HeadingText>Make learning a habit</S.HeadingText>
      <S.SubHeadingText>Meet your child’s long-term learning goals with a Daily Learning Path unique to them</S.SubHeadingText>
      <S.LearningRail delay={'0.3s'}>
        <Image src={LearningPathImg} />
      </S.LearningRail>
      <S.ButtonWrapper>
        <CTAOfferButton white={true} textColor={deepCoveDark} fontWeight="600" hoverColor="rgb(237, 237, 249)">
          <Link to={Routes.PURCHASE_ROUTE} onClick={()=>trackPromoPageEvents("Promo Page Interacted", {'clicked_on' : 'CTA4'}, true)}>
            {ctaText}
        </Link>
        </CTAOfferButton>
      </S.ButtonWrapper>
      <S.BackgroundWrapper>
        <Image src = {LayeredBackground} />
      </S.BackgroundWrapper>
    </S.ContainerWrapper>
  )
}

export default LearningHabit;